import {AfterContentInit, Component, ContentChild, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '@services/auth.service';
import {FontAwesomeService} from '@services/font-awesome.service';

@Component({
  selector: 'app-authentication-wrapper',
  template: `
    <div class="container">
      <div class="left-bar">
        <img src="assets/img/icons/auth-logo.svg">
        <p translate>auth.appName</p>
      </div>
      <div class="right-bar">
        <app-progress-overlay
          [hidden]="!showOverlay"
          [ngClass]="showOverlay ? 'isLoading' : 'notLoading'"></app-progress-overlay>
        <div class="inner-container">
          <ng-content></ng-content>
        </div>
        <div class="footer">
            <div class="copyright">© Copyright 2018, Freightseeker AB</div>
            <div class="language-switcher">
                <a href="javascript:;" (click)="useLanguage('sv')">Svenska</a> -
                <a href="javascript:;"(click)="useLanguage('en')">English</a>
            </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./authentication-wrapper.component.scss']
})
export class AuthenticationWrapperComponent {
  @Input() showOverlay: boolean;
    constructor(
        public translate: TranslateService
    ) {}
    // Change language at runtime
    public useLanguage(language: string) {
      this.translate.use(language);
      sessionStorage.setItem('lang', language);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/authentication-wrapper/authentication-wrapper.component.ts